/**
 * Prévia do `clientId` que o gateway vai gerar para uma credencial nova.
 *
 * ⚠️ Espelha uma regra que vive no gateway (`app-credential-service.js`:
 * `clientId = \`APP-${name.trim().toUpperCase()}\``). Quem é dono do valor é o
 * backend — aqui é só antecipação visual, para o operador ver o identificador
 * antes de salvar. Se a regra mudar lá, esta função e seu teste mudam junto.
 *
 * @param name Nome digitado no formulário.
 * @returns O clientId previsto, ou string vazia quando ainda não há nome.
 */
export const previewClientId = (name: string): string => {
  const trimmed = name.trim()
  return trimmed ? `APP-${trimmed.toUpperCase()}` : ""
}
